import Main from "./Components/Main.js";
import "bulma/css/bulma.min.css";

function App() {
  return <Main />;
}

export default App;
